import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO, { articleJsonLd } from "../components/SEO";
import ShareButton from "../components/ShareButton";
import { api } from "../lib/api";

export default function ArticlePage() {
    const { slug } = useParams();
    const [article, setArticle] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.get(`/articles/${slug}`)
            .then((r) => setArticle(r.data))
            .catch(() => setError("Not found"));
    }, [slug]);

    return (
        <div className="bg-black text-white min-h-screen">
            {article && (
                <SEO
                    title={article.seo_title || article.title}
                    description={article.meta_description || article.excerpt}
                    image={article.image_url}
                    ogSlug={article.slug}
                    type="article"
                    keywords={article.tags || []}
                    jsonLd={articleJsonLd(article)}
                />
            )}
            <Header />
            <main className="max-w-4xl mx-auto px-4 md:px-8 py-12">
                <Link
                    to="/"
                    data-testid="article-back-link"
                    className="inline-flex items-center gap-2 overline text-streetz-muted hover:text-streetz-red"
                >
                    <ArrowLeft className="w-4 h-4" /> BACK TO HOME
                </Link>

                {error && <p className="mt-12 text-streetz-muted">Article not found.</p>}
                {article && (
                    <article data-testid="article-detail" className="mt-8">
                        <span className="overline text-streetz-red">
                            {(article.category || "MUSIC").toUpperCase()}
                        </span>
                        <h1 className="font-display uppercase text-4xl md:text-6xl tracking-tight leading-none mt-4 text-white">
                            {article.title}
                        </h1>
                        <p className="text-streetz-muted mt-4 text-lg">{article.excerpt}</p>
                        <div className="mt-6">
                            <ShareButton
                                title={article.title}
                                text={article.excerpt || ""}
                                articleSlug={article.slug}
                                testId="article-share-button"
                            />
                        </div>
                        {article.image_url && (
                            <img
                                src={article.image_url}
                                alt={article.title}
                                className="w-full aspect-video object-cover mt-8 border border-streetz-line"
                            />
                        )}
                        <div className="mt-8 text-base leading-relaxed text-white/85 whitespace-pre-line">
                            {article.body}
                        </div>
                        {article.tags?.length > 0 && (
                            <div className="mt-10 flex flex-wrap gap-2">
                                {article.tags.map((t) => (
                                    <span
                                        key={t}
                                        className="overline border border-streetz-line px-3 py-1 text-streetz-yellow"
                                    >
                                        {t}
                                    </span>
                                ))}
                            </div>
                        )}
                    </article>
                )}
            </main>
            <Footer />
        </div>
    );
}
